(function() {
  // Function to wrap the inner text of an element in a <span>
  function wrapElementText(el) {
    // Ensure the element has actual text, isn't already wrapped, and is a button
    if (el && el.textContent.trim() && !el.querySelector('span')) {
      
      // Extract the current contents (preserves text and minor nested elements)
      const fragment = document.createDocumentFragment();
      while (el.firstChild) {
        fragment.appendChild(el.firstChild);
      }
      
      // Create the new span element
      const span = document.createElement('span');
      span.className = 'slider_ele_wrapped-inner'; 
      span.appendChild(fragment);
      
      // Append back into clean element
      el.appendChild(span);
    }
  }

  // Scan and target elements on initial load
  function processExisting() {
    document.querySelectorAll('button, .button, [class*="klaviyo-form-button"]').forEach(wrapElementText);
  }

  // Watch for dynamic updates reliably
  const observer = new MutationObserver((mutations) => {
    // Optimize performance: just re-query for unwrapped targets when layout changes
    const buttons = document.querySelectorAll('button:not(:has(span)), .button:not(:has(span)), [class*="klaviyo-form-button"]:not(:has(span))');
    buttons.forEach(wrapElementText);
  });

  // Initialize execution
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processExisting);
  } else {
    processExisting();
  }

  // Start active tracking across the entire document tree
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
class HorizonHoverQuickAdd {
  constructor() {
    this.productData = {};
    this.init();
    this.initObserver();
  }

  init() {
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-drawer-close-mask]')) {
        e.preventDefault();
        this.closeAllActiveDrawers();
        return;
      }

      const triggerBtn = e.target.closest('[data-trigger-expansion-btn]');
      if (triggerBtn) {
        e.preventDefault();
        e.stopPropagation();
        
        const container = triggerBtn.closest('.product-card-quick-add');
        const isMultiVariant = container?.dataset.hasVariants === 'true';
        
        if (isMultiVariant) {
          this.closeAllActiveDrawers();
          const targetPanel = container.querySelector('.quick-add-expanded-drawer-panel');
          if (targetPanel) targetPanel.classList.add('is-open');
        } else {
          const parentId = container?.dataset.product;
          if (parentId) this.handleAddToCart(container, parentId, triggerBtn);
        }

        document.querySelectorAll('.product-grid__item').forEach(slide => {
            slide.classList.remove('quick-add-open');
        });
        const parentSlideColl = triggerBtn.closest('.product-grid__item'); 

        if (parentSlideColl) {
            parentSlideColl.classList.add('quick-add-open');
        }

        document.querySelectorAll('.resource-list__slide').forEach(slide => {
            slide.classList.remove('quick-add-open');
        });
        const parentSlideCollR = triggerBtn.closest('.resource-list__slide'); 

        if (parentSlideCollR) {
            parentSlideCollR.classList.add('quick-add-open');
        }

        return;
      }

      const submitBtn = e.target.closest('[data-submit-button]');
      if (submitBtn) {
        e.preventDefault();
        e.stopPropagation();
        const parent = submitBtn.closest('.product-card-quick-add');
        if (parent?.dataset.product) {
          this.handleAddToCart(parent, parent.dataset.product, submitBtn);
        }
      }
    }, true);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.closeAllActiveDrawers();
    });

    document.addEventListener('change', (e) => {
      if (e.target.matches('.product-card-quick-add input[type="radio"]')) {
        const container = e.target.closest('.product-card-quick-add');
        const productId = container?.dataset.product;
        if (container && productId && this.productData[productId]) {
          this.updateOptionsAvailability(container, this.productData[productId]);
        }
      }
    });
  }

  closeAllActiveDrawers() {
    document.querySelectorAll('.quick-add-expanded-drawer-panel.is-open').forEach(panel => {
      panel.classList.remove('is-open');
    });
  }

  initObserver() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && node.querySelector('.product-card-quick-add')) {
            this.loadProductData(node.querySelector('.product-card-quick-add'));
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
    document.querySelectorAll('.product-card-quick-add').forEach(card => this.loadProductData(card));
  }

  loadProductData(parentContainer) {
    const productId = parentContainer.dataset.product;
    const productHandle = parentContainer.dataset.handle;
    
    if (productHandle && !this.productData[productId]) {
      fetch(`/products/${productHandle}.js`)
        .then(res => res.json())
        .then(data => { 
          this.productData[productId] = data;
          this.selectFirstAvailableVariant(parentContainer, data);
          this.updateOptionsAvailability(parentContainer, data);
        })
        .catch(err => console.error("QuickAdd JSON stream issue:", err));
    }
  }

  selectFirstAvailableVariant(container, product) {
    // Find the first available variant, fallback to first overall variant if completely sold out
    const targetVariant = product.variants.find(v => v.available) || product.variants[0];
    if (!targetVariant) return;

    // Synchronize radio buttons to match this chosen variant's option values
    targetVariant.options.forEach((optionValue, index) => {
      const groupIndex = `option${index + 1}`;
      const radio = container.querySelector(`.option-group[data-option-index="${groupIndex}"] input[type="radio"][value="${CSS.escape(optionValue)}"]`);
      if (radio) {
        radio.checked = true;
      }
    });
  }

  updateOptionsAvailability(container, product) {
    const optionGroups = Array.from(container.querySelectorAll('.option-group'));
    if (!optionGroups.length) return;

    const currentSelections = {};
    optionGroups.forEach(group => {
      const checkedInput = group.querySelector('input[type="radio"]:checked');
      if (checkedInput) {
        currentSelections[group.dataset.optionIndex] = checkedInput.value;
      }
    });

    optionGroups.forEach(group => {
      const groupIndex = group.dataset.optionIndex;
      const radios = group.querySelectorAll('input[type="radio"]');

      radios.forEach(radio => {
        const valueToTest = radio.value;
        const testConfiguration = { ...currentSelections, [groupIndex]: valueToTest };

        const isCombinationAvailable = product.variants.some(variant => {
          const matchOption1 = testConfiguration.option1 ? variant.option1 === testConfiguration.option1 : true;
          const matchOption2 = testConfiguration.option2 ? variant.option2 === testConfiguration.option2 : true;
          const matchOption3 = testConfiguration.option3 ? variant.option3 === testConfiguration.option3 : true;
          return matchOption1 && matchOption2 && matchOption3 && variant.available;
        });

        const labelWrap = radio.closest('.option-value');
        if (isCombinationAvailable) {
          labelWrap.classList.remove('disabled');
          radio.disabled = false;
        } else {
          labelWrap.classList.add('disabled');
          radio.disabled = true;
        }
      });
    });

    const selectedOptions = Array.from(container.querySelectorAll('input[type="radio"]:checked')).map(i => i.value);
    const activeVariant = product.variants.find(v => v.options.every((opt, i) => opt === selectedOptions[i]));
    const submitPriceText = container.querySelector('[data-submit-button] .btn-text-right');
    
    if (activeVariant && submitPriceText) {
      if (window.Shopify && Shopify.formatMoney) {
        submitPriceText.innerHTML = Shopify.formatMoney(activeVariant.price);
      } else {
        const formattedPrice = (activeVariant.price / 100);
        submitPriceText.innerHTML = `£${formattedPrice}`;
      }
    }
  }

  async handleAddToCart(container, productId, targetButtonElement) {
    const submitBtn = targetButtonElement || container.querySelector('[data-submit-button]') || container.querySelector('.direct-add-single-variant-btn');
    
    submitBtn.disabled = true;
    const originalContent = submitBtn.innerHTML;
    
    if (submitBtn.querySelector('.btn-text-left')) {
      submitBtn.querySelector('.btn-text-left').innerHTML = 'adding...';
    } else {
      submitBtn.innerHTML = `<span>adding...</span>`;
    }

    const productHandle = container.dataset.handle;
    
    if (!this.productData[productId]) {
      try {
        const fallbackResponse = await fetch(`/products/${productHandle}.js`);
        this.productData[productId] = await fallbackResponse.json();
      } catch (fetchErr) {
        console.error("Fallback item data fetch failed:", fetchErr);
      }
    }

    const product = this.productData[productId];
    let variantId = null;

    if (!product || (product.options.length === 1 && product.options[0].name === "Title" && product.options[0].values[0] === "Default Title")) {
      variantId = product ? product.variants[0].id : parseInt(container.dataset.variantId || productId);
    } else {
      const selectedOptions = Array.from(container.querySelectorAll('input[type="radio"]:checked')).map(i => i.value);
      const activeVariant = product.variants.find(v => v.options.every((opt, i) => opt === selectedOptions[i]));
      if (activeVariant) variantId = activeVariant.id;
    }

    if (!variantId || isNaN(variantId)) {
      console.error("Could not find a valid variant ID for submission");
      submitBtn.disabled = false;
      submitBtn.innerHTML = originalContent;
      return;
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 'items': [{ 'id': parseInt(variantId), 'quantity': 1 }] })
      });

      if (!response.ok) throw new Error('Cart submission error');

      const cart = await response.json();
      const cartData = await fetch('/cart.js').then(res => res.json());

      document.dispatchEvent(new CustomEvent('cart:update', { 
        bubbles: true, 
        detail: { data: { item_count: cartData.item_count, items: cart.items } } 
      }));

      this.closeAllActiveDrawers();

      const drawer = document.querySelector('cart-drawer-component') || document.querySelector('#CartDrawer');
      if (drawer) {
        if (typeof drawer.open === 'function') drawer.open();
        else drawer.setAttribute('open', '');
      }

    } catch (err) {
      console.error("Cart API Error:", err);
    } finally {
      submitBtn.disabled = false;
      submitBtn.innerHTML = originalContent;
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new HorizonHoverQuickAdd());
} else {
  new HorizonHoverQuickAdd();
}


const observer = new MutationObserver((mutations, obs) => {
  const button = document.querySelector('button.btn.pplr-c-button.pplr-btn.ptc_button');
  
  if (button) {
    button.addEventListener('click', () => {
      if (button.classList.contains('pplr_remove')) {
        document.body.classList.add('no-personalizer');
        document.body.classList.remove('itspersonalizer');
      } else {
        document.body.classList.add('itspersonalizer');
        document.body.classList.remove('no-personalizer');
      }
    });
    // Disconnect observer once we've successfully bound the event
    obs.disconnect(); 
  }
});


// 1. Handle ALL clicks via Event Delegation (No observer needed for clicks)
document.body.addEventListener('click', (e) => {
  const mainButton = e.target.closest('button.btn.pplr-c-button.pplr-btn.ptc_button');
  
  if (mainButton && !mainButton.closest('.pplr_crop-modal')) {
    // This is the main button click!
    console.log('Main button clicked');
    
    // Force a check for the modal text shortly after the click
    setTimeout(fixModalText, 100);
    setTimeout(fixModalText, 400); // Back-up if modal animations take time
  }
});

// 2. The Text Fixing Function
function fixModalText() {
  const modalButton = document.querySelector('.pplr_crop-modal button.btn.pplr-c-button.pplr-btn.ptc_button');
  if (modalButton) {
    const innerSpan = modalButton.querySelector('.slider_ele_wrapped-inner');
    if (innerSpan) {
      innerSpan.textContent = 'ADD TO BASKET';
    } else {
      modalButton.textContent = 'ADD TO BASKET';
    }
  }
}

// 3. Fallback: Run the text fix on a continuous loop ONLY when the modal is open 
// This completely stops the App's internal scripts from overriding your text
setInterval(() => {
  if (document.querySelector('.pplr_crop-modal')) {
    fixModalText();
  }
}, 250);

// Start observing the document
observer.observe(document.body, { childList: true, subtree: true });

// Start observing the document
observer.observe(document.body, { childList: true, subtree: true });


// // Start watching the document body for changes
// observer.observe(document.body, { childList: true, subtree: true });